export enum TransactionsActionType {
  SetState = 'TRANSACTIONS.SET_STATE',
  GET_TRANSACTIONS = 'TRANSACTIONS.GET_TRANSACTIONS',
  GET_TRANSACTIONS_RATES = 'TRANSACTIONS.GET_TRANSACTIONS_RATES',
  WITHDRAW_DEPOSIT = 'TRANSACTIONS.WITHDRAW_DEPOSIT',
}
